import type { Category, Budget } from "@/lib/hooks"
import { Badge } from "@/components/ui/badge"
import { formatAmount } from "@/lib/utils"
import { BUDGET_SCOPE } from "@/lib/constants"

interface SubcategoryProps {
  category: Category
  onTap: (category: Category) => void
  householdBudget?: Budget
  personalBudget?: Budget
}

export function Subcategory({ category, onTap, householdBudget, personalBudget }: SubcategoryProps) {
  return (
    <div
      className="flex items-center justify-between rounded-md px-3 py-2 active:bg-accent/80 cursor-pointer transition-colors"
      onClick={() => onTap(category)}
    >
      <span className="text-sm">
        {category.name}
        {category.owner_id && (
          <Badge variant="outline" className="ml-1 text-[10px] py-0">個人</Badge>
        )}
      </span>
      {(householdBudget || personalBudget) && (
        <span className="text-xs text-muted-foreground tabular-nums">
          {householdBudget && (
            <span className="inline-flex items-center gap-0.5">
              <BUDGET_SCOPE.household.Icon className="h-3 w-3" />
              {formatAmount(householdBudget.amount)}
            </span>
          )}
          {householdBudget && personalBudget && <span className="mx-1">·</span>}
          {personalBudget && (
            <span className="inline-flex items-center gap-0.5">
              <BUDGET_SCOPE.personal.Icon className="h-3 w-3" />
              {formatAmount(personalBudget.amount)}
            </span>
          )}
        </span>
      )}
    </div>
  )
}
